import * as React from 'react';
import {Asset} from "../../api";
import {URL_HELPER} from "../../App";
import { CartItem, SetCart, cartButtonIcon, cartButtonText, toggleCart } from '../utils/CartHelper';


export const AssetComponent: React.FC<{ asset: Asset, cart: CartItem[], setCart: SetCart }> = ({asset, cart, setCart}) => {

    function openPopup() {
        let c_event = new CustomEvent("open-popup", {
            detail: {
                assetId: asset.id
            }
        });

        document.dispatchEvent(c_event);
    }

    return (
        <div className="col-xxl-2 col-xl-3 col-lg-4 col-md-6 mb-4 results-asset" key={asset.id}>
            <div className="results-asset-box" onClick={openPopup}>
                <div className="results-asset-preview pb-2">
                    <img src={URL_HELPER.getThumbnailUrl() + "/" + asset.id} alt={asset.name}/>
                </div>
                <div className="results-asset-title" title={asset.name}>{asset.name}</div>
                <div className="results-asset-extension">{asset.extension}</div>
            </div>
            <a href={URL_HELPER.getDefaultDownloadUrl(asset)} download title="Download default format">
                <div className="w-75 btn btn-secondary p-1">Download</div>
            </a>
            <button className="w-25 btn btn-secondary add-to-cart" onClick={(ev) => {(ev.target as HTMLButtonElement).blur(); toggleCart(asset, cart, setCart)}} title={cartButtonText(asset, cart)}>
                <img src={cartButtonIcon(asset, cart)} className="icon icon-lg" alt="Add / Remove Asset" />
            </button>
        </div>
    );
};
export default AssetComponent;
